import styled from 'styled-components';
import { FlexBox } from '@ardoq/layout';
import { s8 } from '@ardoq/design-tokens';

export const HeaderBarButtonGroup = styled(FlexBox).attrs({ align: 'center' })`
  gap: ${s8};
  margin-right: ${s8};
  margin-left: auto;
  white-space: nowrap;
`;
